export const RULE_REPORT_INPUT_CHANGE = 'RULE_REPORT_INPUT_CHANGE';
export const START_LOAD_RULE_REPORT = 'START_LOAD_RULE_REPORT';
export const LOAD_RULE_REPORT_SUCCESS = 'LOAD_RULE_REPORT_SUCCESS';
export const LOAD_RULE_REPORT_FAILURE = 'LOAD_RULE_REPORT_FAILURE';
export const INIT_LOAD_RULE_REPORT_ACTION_STATUS = 'INIT_LOAD_RULE_REPORT_ACTION_STATUS';
export const START_GENERATE_RULE_REPORT = 'START_GENERATE_RULE_REPORT';
export const GENERATE_RULE_REPORT_SUCCESS = 'GENERATE_RULE_REPORT_SUCCESS';
export const GENERATE_RULE_REPORT_FAILURE = 'GENERATE_RULE_REPORT_FAILURE';
export const INIT_GENERATE_RULE_REPORT_ACTION_STATUS = 'INIT_GENERATE_RULE_REPORT_ACTION_STATUS';
export const OPEN_RESOLVE_RULE_REPORT_MODAL = 'OPEN_RESOLVE_RULE_REPORT_MODAL';
export const CLOSE_RESOLVE_RULE_REPORT_MODAL = 'CLOSE_RESOLVE_RULE_REPORT_MODAL';
export const RESOLVE_RULE_REPORT_CHANGE_INPUT = 'RESOLVE_RULE_REPORT_CHANGE_INPUT';
export const START_UPDATE_RULE_REPORT = 'START_UPDATE_RULE_REPORT';
export const UPDATE_RULE_REPORT_SUCCESS = 'UPDATE_RULE_REPORT_SUCCESS';
export const UPDATE_RULE_REPORT_FAILURE = 'UPDATE_RULE_REPORT_FAILURE';
export const INIT_UPDATE_RULE_REPORT_ACTION_STATUS = 'INIT_UPDATE_RULE_REPORT_ACTION_STATUS';
export const SELECT_RULE_REPORT = 'SELECT_RULE_REPORT';
export const START_STAT_REPORT = 'START_STAT_REPORT';
export const STAT_REPORT_SUCCESS = 'STAT_REPORT_SUCCESS';
export const STAT_REPORT_FAILURE = 'STAT_REPORT_FAILURE';
export const INIT_STAT_REPORT_ACTION_STATUS = 'INIT_STAT_REPORT_ACTION_STATUS';
